import { Component } from '@angular/core';

@Component({
  selector: 'loading-member',
  standalone: true,
  imports: [],
  templateUrl: './loading-member.component.html',
  styleUrl: './loading-member.component.css',
})
export class LoadingMemberComponent {}
